import {Component, EventEmitter} from '@angular/core';
import {ModalComponent} from '../modal-service.service';
import {PlanModelService} from '../../../service/plan-model.service';

@Component({
    selector: 'nlr-lodgement-success-modal',
    imports: [],
    templateUrl: './lodgement-success-modal.component.html',
    styleUrls: ['../modal.scss', './lodgement-success-modal.component.scss']
})
export class LodgementSuccessModalComponent implements ModalComponent {
    title = 'Confirmation';

    modalClosed: EventEmitter<string> = new EventEmitter();
    modalSize: string = 'modal-md';

    constructor(private planModelService: PlanModelService) {}

    getModel() {
        return this.planModelService.getModel();
    }

    closeDialog() {
        this.modalClosed.emit('Close dialog');
    }
}
